// @ts-strict-ignore
import {getCookie, removeCookie, setCookie} from 'common/util/cookie';
import {isStandalone} from 'common/report/util/env';
import {setReferrerSuperpropsAndBaseTracking, setUserBasedTrackingProps} from 'common/report/report-tracker';

// django templates access mp.cookie, mp.utility and _ as globals
// export them in window only if non-standalone (django mode)
if (!isStandalone()) {
  const utility = (mp.utility = mp.utility || {});
  Object.assign(utility, {
    set_referrer_superprops_and_base_tracking: setReferrerSuperpropsAndBaseTracking,
    set_user_based_tracking_props: setUserBasedTrackingProps,
  });

  mp.cookie = {
    set: setCookie,
    get: getCookie,
    remove: removeCookie,
  };
}
